import { render, staticRenderFns } from "./RemoteConsultationTableCmp2.vue?vue&type=template&id=2fb9da30&"
import script from "./RemoteConsultationTableCmp2.vue?vue&type=script&lang=js&"
export * from "./RemoteConsultationTableCmp2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports